import { useDateTime } from "src/utils/hooks"


export const Clock = () => {
	const now = useDateTime()
	let offset
	const isEarlyMorning = now.getUTCHours() < 8
	const isLateNight = now.getUTCHours() >= 22
	const isAPAC = isEarlyMorning || isLateNight
	const isBefore430 = now.getUTCHours() < 16 || (now.getUTCHours() === 16 && now.getUTCMinutes() < 30)
	const isEMEA = !isAPAC && isBefore430
	const isAMER = !isAPAC && !isEMEA

	if (isAPAC) { offset = 11 }
	else if (isEMEA) { offset = 0 }
	else if (isAMER) { offset = -5 }

	const displayHours = ("0" + ((now.getUTCHours() + 24 + offset) % 24)).slice(-2)
	const displayMinutes = ("0" + now.getUTCMinutes()).slice(-2)

	return <h1 id="clock" style="height: 5.4%; left: 47.7%; top: 3.6%; position: absolute; color: black; margin: 0;">
		{displayHours}:{displayMinutes}
	</h1>
}